import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/portal/mdf/requests/:id/cancel — partner withdraws a pending
// request. Pessimistic + confirmation modal at the page layer; the
// destination row state ('cancelled') is terminal from the partner side.
//
// Invalidates the list and detail. Drafts are unaffected (drafts and
// pending are disjoint).
export function useCancelMdf() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, { id: string }>({
    mutationFn: ({ id }) =>
      apiFetch<{ ok: true }>(`/portal/mdf/requests/${id}/cancel`, {
        method: "POST",
      }),
    onSuccess: (_data, { id }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.requests() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.request(id) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to cancel request");
    },
  });
}
